import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("metron_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// ---- Toast padronizado com dedupe (evita mensagens repetidas) ----
let __lastToast = { msg: "", t: 0 };
function notify(msg) {
  const now = Date.now();
  if (msg === __lastToast.msg && now - __lastToast.t < 3500) return;
  __lastToast = { msg, t: now };
  toast.error(msg);
}

let __redirecting = false;

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const cfg = error?.config || {};
    const status = error?.response?.status;
    const url = cfg?.url || "";

    // Log técnico apenas no console (diagnóstico)
    console.error("[API]", cfg?.method?.toUpperCase(), url, status || error?.code || error?.message);

    // Permite que chamadas específicas silenciem o tratamento global
    if (cfg.silent) return Promise.reject(error);

    if (!error.response) {
      // Sem resposta: timeout ou perda de conexão
      if (error.code === "ECONNABORTED") {
        notify("A conexão demorou demais. Tente novamente.");
      } else {
        notify("Sem conexão. Verifique sua internet e tente novamente.");
      }
      return Promise.reject(error);
    }

    if (status === 401) {
      const path = window.location.pathname;
      const publicPage = path.startsWith("/login") || path.startsWith("/registrar") || path.startsWith("/inscricao");
      // Falha de login/sessão em páginas públicas é tratada localmente
      if (!url.includes("/auth/login") && !url.includes("/auth/me") && !publicPage) {
        notify("Sua sessão expirou. Faça login novamente.");
        localStorage.removeItem("metron_token");
        if (!__redirecting) {
          __redirecting = true;
          setTimeout(() => window.location.replace("/login"), 800);
        }
      }
    } else if (status === 403) {
      notify("Você não tem permissão para acessar esta área.");
    } else if (status >= 500) {
      notify("Não foi possível concluir a operação. Tente novamente.");
    } else if (status === 404 && cfg.notifyNotFound) {
      notify("Registro não encontrado.");
    }
    // 400/404/409/422: tratados pelas telas (validação/mensagens específicas)

    return Promise.reject(error);
  }
);

export async function downloadFile(path, filename) {
  const token = localStorage.getItem("metron_token");
  const res = await fetch(`${API}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error("Falha ao exportar");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function apiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
